import Home from '../pages/Home'
import About from '../pages/About'
import Settings from '../pages/Settings'
import Acknowledgements from '../pages/Acknowledgements'

class Pages {
    static getPages() {
        return [
            Home,
            About,
            Settings,
            Acknowledgements,
        ]
    }

    static getTopNavPages() {
        return [
            About,
            Settings,
            Acknowledgements,
        ]
    }
}

export default Pages
